// extracted by mini-css-extract-plugin
export default {"adnetworkDetailButton":"Adnetwork_adnetworkDetailButton__pPLj4"};